import { Purchases, LOG_LEVEL } from "@revenuecat/purchases-capacitor";
import { Capacitor } from "@capacitor/core";

let configuredForUser = null;

function getApiKeyForPlatform() {
  const platform = Capacitor.getPlatform();

  if (platform === "ios") {
    return process.env.REACT_APP_REVENUECAT_IOS_KEY || null;
  }
  if (platform === "android") {
    return process.env.REACT_APP_REVENUECAT_ANDROID_KEY || null;
  }
  return null; // web
}

/**
 * Initialize RevenueCat once per logged-in user.
 * Call after you have a Firebase uid.
 */
export async function initRevenueCat(uid) {
  if (!uid) return;
  if (!Capacitor.isNativePlatform()) return;

  // Avoid re-configuring if already configured for this user
  if (configuredForUser === uid) return;

  const apiKey = getApiKeyForPlatform();
  if (!apiKey) {
    console.warn(
      "[RevenueCat] Missing API key for platform:",
      Capacitor.getPlatform()
    );
    return;
  }

  await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });

  await Purchases.configure({
    apiKey,
    appUserID: uid, // since login is required
  });

  configuredForUser = uid;
}
